module.exports = __webpack_public_path__ + "img/icon-sun.41de8506.svg";